import { h, Component } from 'preact';
// import Store from 'store/store';
// import * as actions from 'store/actions';

export default class Video extends Component {

	constructor() {
		super();
		this.currentVideo = 0;
		this.$videos = [];
	}

	componentDidMount() {
		let vid = this.$videos[this.currentVideo];

		if (typeof this.props.isPlaying === 'function') {
			vid.addEventListener('play', this.props.isPlaying);
		}

		if (typeof this.props.isPaused === 'function') {
			vid.addEventListener('pause', this.props.isPaused);
		}

		if (!vid) return;

		if (this.props.paused) {
			vid.pause();
		} else if (this.props.autoplay) {
			// Check if the video is actually playing
			let onLoad = () => {
				vid.removeEventListener('loadedmetadata', onLoad);
				// Will cause a flash on older devices if styling is linked to video playing.
				if (vid.paused) vid.play();
			};
			if (vid.readyState >= 1) {
				onLoad();
			} else {
				vid.addEventListener('loadedmetadata', onLoad);
				if (typeof vid.load === 'function') {
					vid.load();
				}
			}
		}

		document.body.addEventListener('touchstart', this.playVid);

	}

	componentWillReceiveProps(props) {
		if (props.paused !== this.props.paused && this.$videos && this.$videos[this.currentVideo]) {
			this.$videos[this.currentVideo][props.paused ? 'pause' : 'play']();
		}
		if (props.muted !== this.props.muted && this.$videos) {
			this.$videos.forEach(vid => vid.muted = props.muted);
		}
	}

	shouldComponentUpdate() {
		return false;
	}

	componentWillUnmount() {
		let vid = this.$videos[this.currentVideo];
		if (typeof this.props.isPlaying === 'function') {
			vid.removeEventListener('play', this.props.isPlaying);
		}
		if (typeof this.props.isPaused === 'function') {
			vid.removeEventListener('pause', this.props.isPaused);
		}

		document.body.removeEventListener('touchstart', this.playVid);

	}

	getRef() {
		return this.$videos[this.currentVideo];
	}

	playVid = () => {
		let vid = this.$videos[this.currentVideo];
		vid.play();
	};

	switchVid = () => {
		let current = this.$videos[this.currentVideo];
		this.currentVideo = 1 - this.currentVideo;

		let alt = this.$videos[this.currentVideo];
		alt.play();
		alt.style.opacity = 1;
		alt.id = 'bgVideo';

		current.style.opacity = 0;
		current.pause();
		current.currentTime = 0;
		current.id = '';
	};

	render(props) {
		delete props.paused; // Used by our own thing

		return (
			<div class={props.containerClass}>
				<video
					id={this.props.isBgVideo ? 'bgVideo' : 'video'}
					class={props.class}
					{...props}
					ref={$ref => $ref && (this.$videos[0] = $ref)}
				/>
			</div>
		);
	}

}
